import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AnalyticsSummary, TeamAnalytics } from "../domain/analytics.types";

export type AnalyticsStatus = "idle" | "loading" | "succeeded" | "failed";

export interface AnalyticsState {
  summary: AnalyticsSummary | null;
  byTeam: TeamAnalytics[];
  status: AnalyticsStatus;
  error: string | null;
}

const initialState: AnalyticsState = {
  summary: null,
  byTeam: [],
  status: "idle",
  error: null,
};

const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    analyticsRequestStarted(state) {
      state.status = "loading";
      state.error = null;
    },
    analyticsLoaded(
      state,
      action: PayloadAction<{ summary: AnalyticsSummary; byTeam: TeamAnalytics[] }>,
    ) {
      state.summary = action.payload.summary;
      state.byTeam = action.payload.byTeam;
      state.status = "succeeded";
    },
    analyticsRequestFailed(state, action: PayloadAction<string>) {
      state.status = "failed";
      state.error = action.payload;
    },
  },
});

export const { analyticsRequestStarted, analyticsLoaded, analyticsRequestFailed } =
  analyticsSlice.actions;

export default analyticsSlice.reducer;
